import { render, staticRenderFns } from "./financail-managment.vue?vue&type=template&id=55681680"
import script from "./financail-managment.vue?vue&type=script&lang=js"
export * from "./financail-managment.vue?vue&type=script&lang=js"
import style0 from "./financail-managment.vue?vue&type=style&index=0&id=55681680&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports